import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

document.getElementById("hamburger").addEventListener("click", function () {
  document.getElementById("hamburger").classList.toggle("open");
  document.getElementById("slide").classList.toggle("show");
  document.getElementById("slideMask").classList.toggle("show");
});

document.getElementById("slideMask").addEventListener("click", function () {
  document.getElementById("hamburger").classList.remove("open");
  document.getElementById("slide").classList.remove("show");
  document.getElementById("slideMask").classList.remove("show");
});

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementById("faq") !== null) {
    document.querySelectorAll(".faq__question").forEach((element) => {
      element.addEventListener("click", function () {
        element.classList.toggle("open");
        element.nextElementSibling.classList.toggle("open");
        if (element.nextElementSibling.classList.contains("open")) {
          element.nextElementSibling.style.height = element.nextElementSibling.scrollHeight + "px";
        } else {
          element.nextElementSibling.style.height = "0px";
        }
      });
    });
  }
});

if (document.getElementById("fvSlider") !== null) {
  const fvSlider = new Swiper("#fvSlider", {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    speed: 1000,
    effect: "fade",
    autoplay: {
      delay: 4000,
    },
  });
}

if (document.getElementById("infoSlider") !== null) {
  const infoSlider = new Swiper("#infoSlider", {
    loop: true,
    centeredSlides: true,
    slidesPerView: 3,
    speed: 1000,
    spaceBetween: 10,
    breakpoints: {
      1024: {
        slidesPerView: 4,
      },
      767: {
        spaceBetween: 30,
      },
    },
    autoplay: {
      delay: 4000,
    },
  });
}

if (document.getElementById("exampleSlider") !== null) {
  const exampleSlider = new Swiper("#exampleSlider", {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    speed: 1000,
    spaceBetween: 20,
    autoplay: {
      delay: 4000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}

if (document.getElementById("news") !== null) {
  document.getElementById("newsMoreBtn").addEventListener("click", function () {
    document.querySelectorAll(".news__item.hide").forEach((element) => {
      element.classList.remove("hide");
    });
    document.getElementById("newsMoreBtn").remove();
  });
}
